import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { RecordsToRemove, WacPagesMethod, WacPagesRecord } from '../types';

export class WebAccessControlCustomPagesBaseDataProvider extends BaseWebComponentDataProvider {
  private endpoint = 'WebAccessControlCustomPages';
  private dataProviderType = DataProviderType.ENDPOINTS;

  public async getDataForView() {
    return {};
  }

  public async removeRecords(records: Array<WacPagesRecord>): Promise<{ success:boolean }> {
    const payload: { records: Array<RecordsToRemove> } = {
      records: records.map((item: RecordsToRemove) => {
        const { _id, company } = item;
        return { _id, company };
      }),
    };

    return ConsoleRequest.createRequest<{ success:boolean }>({
      dataProviderType: this.dataProviderType,
      payload: payload,
      endpoint: this.endpoint,
      method: WacPagesMethod.REMOVE_RECORDS,
    });
  }

}
